<template>
    <div>
        <header-nav :cur="1" />
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>&nbsp;
                    <span class="two" @click="back()">资讯</span>
                    &nbsp;>&nbsp;
                    <span class="infor">文章内容</span>
                </span>
            </div>
        </div>
        <!-- 底部 -->
        <div class="navtab">
            <div class="content">
                <div class="title" style="padding-left:20%;font-size:28px;display: inline-block;padding-top:50px">{{item.articleTitle}}</div>
                <div class="time" style="padding-left:25%;font-size:20px">
                    <span>发布时间：{{item.createTime}}</span>
                    <span>阅读量：{{item.number_hit}}</span>
                    <span>作者：{{item.authorName}}</span>
                </div>
            </div>
            <div class="contdetail ql-editor" v-html="item.content">
            </div>
        </div>
        <footer-nav />
    </div>
</template>
<script>
import {queryArticleList,queryArticleById,latestArticleList} from '@/api/article.js'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
			id:'',
			item:{}
		};
    },
	created() {
		this.id = this.$route.query.id;
		this.queryArticleInfo(this.id);
	},
    methods: {
		queryArticleInfo(id){
			var parm = {
				id:id
			}
			queryArticleById(parm).then(res => {
				this.item = res.data;
			})
		},
        back() {
            this.$router.back(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 60px;
        .top {
            display: block;
            font-size: 16px;

            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            .two {
                cursor: pointer;
                color: #777777;
            }
            .infor {
                color: #ff6a00;
            }
        }
    }
   
</style>
